import { useState } from "react";
import { AuthApiService } from "../../services/api/AuthApiService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from "../../shared/constants";
import { useParams, useNavigate } from "react-router-dom";
import AuthWrapper from "../../components/Authwrapper";
import { Button, Grid, Stack, TextField, Typography,Snackbar, Alert } from "@mui/material";
import OtpInput from "react-otp-input";

function RequestOTP() {
  const { phoneNumber } = useParams();
  const navigate = useNavigate();
  const [phone, setPhone] = useState(phoneNumber || "");
  const [otp, setOtp] = useState("");
  const [status, setStatus] = useState("");
  const [snackData, setSnackData] = useState({
      show: false,
      message: "",
      type: "error",
    });

  const handleSendOtp = async () => {
    let payload = {
      phone: phone,
    };
    AuthApiService.requestOTP(payload)
      .then((response) => {
        console.log("response", response);
        setStatus(true);
        setSnackData({
          show: true,
          message: API_SUCCESS_MESSAGE.OTP_SENT,
          type: "success",
        });
      })
      .catch((errResponse) => {
          setSnackData({
            show: true,
            message: errResponse?.response?.data?.error || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
            type: "error",
          });

      });
  };

  const handleOtpLogin = async () => {
    let payload = {
      phone: phone,
      otp: otp,
    };
    AuthApiService.OTPLogin(payload)
      .then((response) => {
        if(sessionStorage.getItem("redirect_type") === "journal")
        {
          navigate(`/user/${phone}/login?type=journal&token=${response?.access_token}`)
        }
        else{
          navigate(`/user/${phone}/login?token=${response?.access_token}`)
        }
      })
      .catch((errResponse) => {
          setSnackData({
            show: true,
            message: errResponse?.response?.data?.error || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
            type: "error",
          });
      });
  };

  return (
    <AuthWrapper>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{status ? "Verify" : "Request"}</Typography>
        </Grid>
        {!status ? (
          <>
            <Grid item xs={12}>
              <Stack spacing={1}>
                <TextField
                  required
                  id="phone"
                  type="text"
                  value={phone || ""}
                  label="Phone"
                  name="phone"
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter phone number"
                  fullWidth
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                onClick={handleSendOtp}
              >
                Request One Time Pin
              </Button>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
              <OtpInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                renderSeparator={<span>-</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  width: "14%",
                  maxWidth: "2.5rem",
                  minWidth: "2rem",
                  height: "2.5rem",
                  margin: "0 4px",
                  fontSize: "1rem",
                  borderRadius: 4,
                  border: "1px solid rgba(0,0,0,0.3)",
                  textAlign: "center",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                onClick={handleOtpLogin}
              >
                Verify One Time Pin
              </Button>
            </Grid>
          </>
        )}
      </Grid>
      <Snackbar
      style={{top:"80px"}}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
    </AuthWrapper>
  );
}

export default RequestOTP;
